export default __webpack_public_path__ + "static/media/deposit-ico.b9332ce0.webp";